// extracted by mini-css-extract-plugin
export default {"icon":"Icon_icon__kw2Ca","contianer":"Icon_contianer__LUWn0","hidden":"Icon_hidden__9ZvS9","shown":"Icon_shown__r50Y6"};